import {useQueryResponseData, useQueryResponseLoading} from "../../core/QueryResponseProvider";
import {useMemo} from "react";
import {actionColumns} from "./columns/_columns";
import {ColumnInstance, Row, useTable} from "react-table";
import {KTCardBody} from "../../../../../../_metronic/helpers";
import {CustomHeaderColumn} from "./columns/CustomHeaderColumn";
import {CustomRow} from "./columns/CustomRow";
import {ChecklistListPagination} from "../../components/pagination/ChecklistListPagination";
import {ChecklistListLoading} from "../../components/loading/ChecklistListLoading";


const ImplementationActionTable = () => {
  const sites = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data1 = useMemo(() => sites,[sites])
  const data= data1;
  const columns = useMemo(() => actionColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })
  return(
    <KTCardBody>
      <div className="table-responsive">
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            {headers.map((column: ColumnInstance<any>) => (
              <CustomHeaderColumn key={column.id} column={column} />
            ))}
          </tr>
          </thead>
          <tbody className='text-gray-600 fw-500' {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row: Row<any>, i) => {
              prepareRow(row)
              return <CustomRow row={row} key={`row-${i}-${row.id}`} />
            })
          ) : (
            <tr>
              <td colSpan={8}>
                <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                  Kayıt bulunanmamıştır.
                </div>
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>

      <ChecklistListPagination />
      {isLoading && <ChecklistListLoading />}
    </KTCardBody>
  )
}

export {ImplementationActionTable}